import { Box } from '@givebutter/primitives/box';
import { Separator } from '@givebutter/primitives/separator';
import { CampaignAppealSettings } from './CampaignAppealSettings';
import { CampaignExpertsSettings } from 'assets/js/pages/campaign-settings/campaign-settings/CampaignExpertsSettings';
import { CampaignFeeSettings } from 'assets/js/pages/campaign-settings/campaign-settings/CampaignFeeSettings';
import { CampaignGeneralSettings } from 'assets/js/pages/campaign-settings/campaign-settings/CampaignGeneralSettings';
import { CampaignOtherSettings } from 'assets/js/pages/campaign-settings/campaign-settings/CampaignOtherSettings';
import { CampaignThankYouSettings } from 'assets/js/pages/campaign-settings/campaign-settings/CampaignThankYouSettings';
import { useFlags } from 'launchdarkly-react-client-sdk';

const CampaignSettings = () => {
    const { appeals = false } = useFlags();
    return (
        <Box className={'flex flex-col gap-8 p-8'}>
            <CampaignGeneralSettings />
            <Separator />
            <CampaignThankYouSettings />
            <Separator />
            <CampaignFeeSettings />
            {appeals && (
                <>
                    <Separator />
                    <CampaignAppealSettings />
                </>
            )}
            <Separator />
            <CampaignOtherSettings />
            <Separator />
            <CampaignExpertsSettings />
        </Box>
    );
};

export default CampaignSettings;
